<mat-form-field class="mat-dropdown">
  <mat-select
    data-cy="dashboard__cards__state_filter"
    (selectionChange)="sortChange($event)"
    [(value)]="selectedSort"
    >
    <mat-select-trigger>
      {{selectedSortLabel}}
    </mat-select-trigger>
    @for (sort of sorts; track sort) {
      <mat-option
        [attr.data-cy]="'dashboard__cards__state_filter__option_' + sort.value.toLowerCase()"
        [value]="sort.value"
        >
        <span>
          {{sort.label}}
        </span>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
